export function handleAnchorClick() {
  const header = document.querySelector('.anchor-menu');
  const wrapper = document.querySelector('.anchor-menu__wrapper');
  const breakpoint = 1072;

  if (header) {
    // Handle click on the anchor menu header; opens like an accordion on smaller breakpoint
    header
      .querySelector('.anchor-menu__header')
      .addEventListener('click', () => {
        window.getSelection().removeAllRanges();
        header.classList.toggle('anchor-menu--open');
        document.querySelector('.anchor-menu__links').scrollIntoView();
      });

    // Handle when the menu becomes sticky.
    // Detects when the menu intersects and applies the sticky class
    const stickyObserver = new IntersectionObserver(
      ([e]) => {
        if (e.boundingClientRect.top < 0) {
          e.target.classList.add('is-sticky');
        } else {
          e.target.classList.remove('is-sticky');
        }
      },
      {
        threshold: 1,
        rootMargin: '0px 0px -1px 0px',
      },
    );
    stickyObserver.observe(wrapper);

    // Handle clicks on each anchor item, applied active class
    const items = document.getElementsByClassName('anchor-menu__link');

    // Need to close the anchor menu after it has been clicked
    Array.from(items).forEach((item) => {
      item.addEventListener('click', () => {
        header.classList.toggle('anchor-menu--open');
      });
    });

    // Toggle the active state to a given anchor menu link
    const changeAnchorActive = (list, current) => {
      Array.from(list).forEach((remove) => {
        remove.classList.remove('anchor-menu__link--active');
      });
      current.classList.toggle('anchor-menu__link--active');
    };

    // Handle what happens when a new anchor menu section come into the view port
    const onIntersect = (targets) => {
      targets.forEach((target) => {
        if (!target.isIntersecting) return;
        // Find the link that has the href to this element, apply the active state to it
        changeAnchorActive(
          items,
          document.querySelector(`a[href="#${target.target.id}"]`).parentElement,
        );
      });
    };

    const top = window.innerWidth > breakpoint
      ? document.getElementById('header').offsetHeight
      : document.querySelector('.anchor-menu').offsetHeight + 96;
    const bottom = window.innerHeight;
    // How far (in pixels) below the header (and anchor menu on mobile)
    // should the intersection observer start
    const intersectionStart = 30;
    const instersectionHeight = 50;

    // Settings for intersection observer
    const options = {
      // Set up a tiny slice of the viewport just below the header
      rootMargin: `-${top + intersectionStart}px 0px -${
        bottom - top + intersectionStart + instersectionHeight
      }px 0px`,
      threshold: 0,
    };
    // Create the observer
    const anchorOberserver = new IntersectionObserver(onIntersect, options);
    const headings = document.getElementsByClassName('anchor-heading');

    // Let it observe all the headings on the page
    Array.from(headings).forEach((heading) => {
      anchorOberserver.observe(heading);
    });
  }
}

export default handleAnchorClick;
